// extracted by mini-css-extract-plugin
export default {"news_top":"styles_news_top__t2q0S","calendar_btn":"styles_calendar_btn__nphOW","all_news_btn":"styles_all_news_btn__+uf+j","calendar":"styles_calendar__YC5Sh"};